import * as React from 'react';
import { Route } from 'react-router';

import VideoLoggedOutApp from 'bundles/video-logged-out-page/components/VideoLoggedOutApp';

export default (
  <Route path="/" component={VideoLoggedOutApp}>
    {/* The legacy VLP route — VideoLoggedOutApp redirects to the CDP. */}
    <Route path="lecture/:courseSlug/:itemSlugAndId" />
  </Route>
);
